import React, { createContext, useState, useContext, useEffect } from "react";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItems, setCartItems] = useState(() => {
    // Try to load from localStorage
    if (typeof window !== "undefined") {
      const saved = localStorage.getItem("cartItems");
      return saved ? JSON.parse(saved) : [];
    }
    return [];
  });
  const [cartVisible, setCartVisible] = useState(false);

  const addToCart = (item) => {
    setCartItems((prevItems) => {
      // Check if same item already exists with same rental type and dates
      const existingItem = prevItems.find(
        (i) =>
          i.id === item.id &&
          i.rentalType === item.rentalType &&
          i.startDate === item.startDate &&
          i.endDate === item.endDate
      );

      if (existingItem) {
        return prevItems.map((i) =>
          i.id === existingItem.id ? { ...i, quantity: i.quantity + 1 } : i
        );
      }

      return [...prevItems, item];
    });
    setCartVisible(true);
  };

  const updateCartItem = (id, updates) => {
    setCartItems((prevItems) =>
      prevItems.map((item) => (item.id === id ? { ...item, ...updates } : item))
    );
  };

  const removeFromCart = (id) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== id));
  };

  const clearCart = () => {
    setCartItems([]);
  };

  const calculateSubtotal = () => {
    return cartItems.reduce(
      (sum, item) => sum + item.totalPrice * item.quantity,
      0
    );
  };
  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("cartItems", JSON.stringify(cartItems));
    }
  }, [cartItems]);
  const calculateTax = () => {
    return calculateSubtotal() * 0.1; // 10% tax
  };

  const calculateTotal = () => {
    return calculateSubtotal() + calculateTax();
  };

  const toggleCart = () => {
    setCartVisible(!cartVisible);
  };

  return (
    <CartContext.Provider
      value={{
        cartItems,
        cartVisible,
        addToCart,
        updateCartItem,
        removeFromCart,
        clearCart,
        calculateSubtotal,
        calculateTax,
        calculateTotal,
        toggleCart,
        setCartVisible,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
